var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "p-1 flex items-center justify-between gap-4 rounded bg-pure-white"
    },
    [
      _c(
        "div",
        {
          staticClass: "flex items-center gap-1 truncate",
          attrs: { title: _vm.nameString }
        },
        [
          !_vm.checkable
            ? _c("BlIcon", {
                staticClass: "h-4 w-4",
                attrs: { icon: "file", color: "slate-6" }
              })
            : _c("input", {
                staticClass: "cursor-pointer",
                attrs: { type: "checkbox" },
                domProps: { checked: _vm.checked },
                on: {
                  change: function($event) {
                    return _vm.$emit("check-handler")
                  }
                }
              }),
          _vm._v(" "),
          _vm.url
            ? _c(
                "a",
                {
                  staticClass: "cursor-pointer truncate",
                  attrs: { href: _vm.url, target: "_blank" }
                },
                [
                  _c("BlTextBody2", {
                    staticClass:
                      "underline text-slate-800 font-semibold truncate",
                    attrs: { text: _vm.nameString }
                  })
                ],
                1
              )
            : _c("BlTextBody2", {
                staticClass: "underline text-slate-800 font-semibold truncate",
                attrs: { text: _vm.nameString }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex items-center gap-1 flex-shrink-0" },
        [
          _vm.sizeString
            ? _c("BlTextBody2", {
                staticClass: "flex-shrink-0",
                attrs: { text: "" + _vm.sizeString }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c("div", { staticClass: "blum-loader-xs" })
            : _vm.removeable
            ? _c("BlIcon", {
                staticClass: "h-4 w-4",
                attrs: {
                  icon: "delete",
                  color: "slate-6",
                  title: "Remove",
                  clickable: ""
                },
                on: { clicked: _vm.onRemove }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bb06162", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bb06162","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlFileHolder.vue
// module id = null
// module chunks = 